var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"ep-loader"},[_c('span',{staticClass:"ep-loader--dot"}),_c('span',{staticClass:"ep-loader--dot"}),_c('span',{staticClass:"ep-loader--dot"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }